module.exports = __webpack_public_path__ + "img/clock.4ab30bdc.png";